import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";

const SuccessTooltipContent = ({ name, address, t }) => {
  return (
    <div>
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          marginLeft: "1em",
          paddingLeft: "0px",
        }}
        className="col-12"
      >
        <h5 className="date_header label-euro">
          <span className="label_title"> {t("resume.entities.tooltip.entity")}: </span>
        </h5>
        <b className="label-euro" style={{ marginLeft: "5px" }}>
          {name || ""}
        </b>
      </div>
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          marginLeft: "1em",
          paddingLeft: "0px",
        }}
        className="col-12"
      >
        <h5 className="date_header label-euro">
          <span className="label_title"> {t("resume.entities.tooltip.address")}: </span>
        </h5>
        <b className="label-euro" style={{ marginLeft: "5px" }}>
          {address || ""}
        </b>
      </div>
    </div>
  );
};

const FailureTooltipContent = ({ t }) => {
  return (
    <div>
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          marginLeft: "1em",
          paddingLeft: "0px",
        }}
        className="col-12"
      >
        <h5 className="date_header label-euro">
          <span className="label_title colorRed bold"> {t("resume.entities.tooltip.notAssociated")} </span>
        </h5>
      </div>
    </div>
  );
};

const EntityTooltip = ({ t, entity }) => {
  const { tooltipValue, tooltipAddress, idName } = entity;
  const condition = tooltipValue || tooltipAddress;

  if (idName === "DeliveryName") {
    return null;
  }
  const tooltipComponent = condition ? (
    <SuccessTooltipContent name={tooltipValue} address={tooltipAddress} t={t} />
  ) : (
    <FailureTooltipContent t={t} />
  );
  return (
    <Tooltip
      style={{ marginLeft: "5px" }}
      placement="right"
      title={tooltipComponent}
    >
      <span className={`icon-informative-tooltip custom-icon-tooltip ${condition ? "green" : "red"}`} />

      {/* <em
        className={`icon-final-25 mr-3 euro-info-icon ${condition ? "colorGreen" : "colorRed"
          }`}
      /> */}
    </Tooltip>
  );
};

export default withNamespaces()(withRouter(EntityTooltip));
